module.exports = __webpack_public_path__ + "img/_DSC1076 2.584cf5a3.png";